(function (angular) {
    var $Loading = /** @class */ (function () {
        function $Loading($ionicLoading) {
            this.$ionicLoading = $ionicLoading;
        }
        $Loading.prototype.show = function (options) {
            var template = '<md-progress-circular md-mode="indeterminate" md-diameter="70"></md-progress-circular>';
            if (options) {
                if (options.title)
                    template = template + '<div class="title">' + options.title + '</div>';
            }
            var opts = _.extend({
                template: template
            }, options);
            this.$ionicLoading.show(opts);
        };
        $Loading.prototype.hide = function () {
            this.$ionicLoading.hide();
        };
        // For promise
        $Loading.prototype.blockUI = function(options){
            this.show(options);
            return ()=>{
                this.hide();
            }
        }
        return $Loading;
    }());
    angular.module('shared').service('$Loading', ['$ionicLoading', $Loading]);
}(angular));
